import izitoast from 'izitoast'

export const buildNotification = ({ title = '', message = '', progressBarColor = 'rgb(0, 255, 184)' }) => {
  izitoast.show({
    id: 'haduken',
    theme: 'dark',
    title,
    displayMode: 2,
    message,
    position: 'topCenter',
    transitionIn: 'flipInX',
    transitionOut: 'flipOutX',
    progressBarColor,
    layout: 2,
    iconColor: 'rgb(0, 255, 184)',
  })
}

export const getMatchBatchClass = status => {
  switch (status) {
  case 'live': return 'orange'
  case 'upcoming': return 'light-gray'
  default: return 'gray'
  }
}
